if (typeof jQuery === "undefined") {
    throw new Error("MazakaCore requires jQuery");
}

$.Counter = {
    Starter: function (that) {
        function getTimeRemaining(endtime) {
            var t = Date.parse(endtime) - Date.parse(new Date());
            var seconds = Math.floor((t / 1000) % 60);
            var minutes = Math.floor((t / 1000 / 60) % 60);
            var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
            //var days = Math.floor(t / (1000 * 60 * 60 * 24));
            return {
                total: t,
                //'days': days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
            };
        }

        function initializeClock(id, endtime) {
            var clock = document.getElementById(id);
            //var daysSpan = clock.querySelector('.days');
            var hoursSpan = clock.querySelector(".hours");
            var minutesSpan = clock.querySelector(".minutes");
            var secondsSpan = clock.querySelector(".seconds");

            function updateClock() {
                var t = getTimeRemaining(endtime);

                //daysSpan.innerHTML = t.days;
                hoursSpan.innerHTML = ("0" + t.hours).slice(-2);
                minutesSpan.innerHTML = ("0" + t.minutes).slice(-2);
                secondsSpan.innerHTML = ("0" + t.seconds).slice(-2);

                if (t.total <= 0) {
                    clearInterval(timeinterval);
                }
            }

            updateClock();
            var timeinterval = setInterval(updateClock, 1000);
        }

        var deadline = new Date(Date.parse(new Date()));
        initializeClock("clockdiv", deadline);
    }
};

$.Cart = {
    IncDetail: function (that) {
        var addToCartAmount = $(that).parent().find("[name='addToCartAmount']");
        startValue = $(addToCartAmount).val();
        var increment = $.Util.ToNumber($(that).attr("data-increment"));
        var dataMax = $(that).attr("data-max");
        var max = $.Util.ToNumber(dataMax);
        var detailAmount = parseFloat(startValue) + parseFloat(increment);
        var stockState = detailAmount <= max;
        if (dataMax && detailAmount > max) {
            return;
        }
        $(addToCartAmount).val(detailAmount);
        $(addToCartAmount).change();
    },
    DecDetail: function (that) {
        var addToCartAmount = $(that)
            .parent()
            .find("[name='addToCartAmount']");
        startValue = $(addToCartAmount).val();
        var decrement = $.Util.ToNumber($(that).attr("data-increment"));
        var isProductGroup = $(that).attr("group-product") === "true";
        if (isProductGroup) {
            if (startValue - decrement >= 0) {
                startValue -= decrement;
                $(addToCartAmount).val(startValue);
            }
        } else {
            if (startValue - decrement > 0) {
                startValue -= decrement;
                $(addToCartAmount).val(startValue);
            }
        }
        $(addToCartAmount).change();
    },
    AddCart: function (that) {
        $(that).attr("disabled", true);
        var addCartType = $("#CartController").attr("add-cart-type");
        if (addCartType === "cart") {
            var loadingCart = $(that)
                .closest(".load")
                .find(".loading");
            $(loadingCart).fadeIn("fast");
        } else if (addCartType === "popup") {
            $("#add-cart-modal .cart-modal-loading").show();
            $("#add-cart-modal .cart-modal-content").hide();
            $("#add-cart-modal").modal("show");
        } else {
            var cart = $(that)
                .closest(".index-pro")
                .find(".btnAddToBasket");
            var loading = $(that)
                .closest(".load")
                .find(".loading");
            $(cart).fadeOut("fast");
            $(loading).fadeIn("fast");
        }

        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var addToCartAmount = $(that).closest(".add-cart").find("[name='addToCartAmount']");
        var quantity = parseFloat($(addToCartAmount).val());
        var defaultQuantity = $.Util.ToNumber($(that).attr("data-quantity"));
        var image = $(that).attr("data-img");
        var name = $(that).attr("data-name");
        var price = $(that).attr("data-price-with-discount");
        var variantValues = $(that).attr("data-variant");

        var params = {
            productID: productID,
            quantity: quantity || defaultQuantity,
            AddCartType: addCartType
        };
        if (variantValues) {
            params.variantValues = JSON.parse(variantValues);
        }
        $.FacebookPixel.AddToCart(productCode, price);

        var googleProduct = {
            id: productCode,
            name: name,
            list_name: "Search Results",
            quantity: quantity,
            price: price
        }
        if (variantValues) {
            googleProduct.variant = JSON.parse(variantValues);
        }
        $.Analytics.Add_To_Cart(googleProduct);

        return angular
            .element(".cart-controller")
            .scope()
            .vm.InsertWithParams(params)
            .then(function () {
                $(that).attr("disabled", false);
                if (addCartType === "cart") {
                    window.location = "/Cart/Index";
                } else if (addCartType === "popup") {
                    $("#add-cart-modal .cart-modal-product-image").attr("src", imageServer + "/" + image);
                    $("#add-cart-modal .cart-modal-product-name").html(name);
                    $("#add-cart-modal .cart-modal-loading").hide();
                    $("#add-cart-modal .cart-modal-content").show();
                } else {
                    $(cart).fadeIn("fast");
                    $(loading).fadeOut("fast");
                    var success = $(that)
                        .closest(".border-urun")
                        .find(".SuccessText");
                    $(success)
                        .fadeIn("fast")
                        .delay(3000)
                        .fadeOut("fast");
                }
            }, function (error) {
                $(that).attr("disabled", false);
                if (addCartType === "popup") {
                    $("#add-cart-modal").modal("hide");
                } else if (addCartType === "cart") {} else {
                    $(cart).fadeIn("fast");
                    $(loading).fadeOut("fast");
                }
                alert(error)
            });
    },
    AddFavorite: function (that, callback) {
        if (!userId) {
            window.location = "/account/loginorsignup?ReturnUrl=" + window.location.href;
            return;
        } else {
            $(that).attr("disabled", true);
            var cart = $(that).closest(".index-pro").find(".btnAddToBasket");
            var loading = $(that).closest(".load").find(".loading");
            $(cart).fadeOut("fast");
            $(loading).fadeIn("fast");

            var productID = $(that).attr("data-id");

            var params = {
                productID: productID,
                CartType: 'Favorite'
            };

            return angular
                .element(".cart-controller")
                .scope()
                .vm.InsertWithParams(params)
                .then(function () {
                    $(that).attr("disabled", false);
                    $(cart).fadeIn("fast");
                    $(loading).fadeOut("fast");
                    var success = $(that).closest(".border-urun").find(".SuccessText");
                    $(success).fadeIn("fast").delay(3000).fadeOut("fast");
                    callback(that);
                });
        }
    },
    AddCompare: function (that, callback) {
        $(that).attr("disabled", true);
        var cart = $(that).closest(".index-pro").find(".btnAddToBasket");
        var loading = $(that).closest(".load").find(".loading");
        $(cart).fadeOut("fast");
        $(loading).fadeIn("fast");

        var productID = $(that).attr("data-id");

        var params = {
            productID: productID,
            CartType: 'Compare',
            Quantity: 1
        };

        return angular
            .element(".cart-controller")
            .scope()
            .vm.InsertWithParams(params)
            .then(function () {
                $(that).attr("disabled", false);
                $(cart).fadeIn("fast");
                $(loading).fadeOut("fast");
                var success = $(that).closest(".border-urun").find(".SuccessText");
                $(success).fadeIn("fast").delay(3000).fadeOut("fast");
                callback(that);
            }, function (data) {
                angular
                    .element(".cart-controller")
                    .scope()
                    .vm.loading = false;
                alert("Karşılaştırma listesine en fazla 4 ürün ekleyebilirsiniz.")
            });
    },
    AddStock: function (that, callback) {
        if (!userId) {
            window.location = "/account/loginorsignup?ReturnUrl=" + window.location.href;
            return;
        } else {
            $(that).attr("disabled", true);
            var cart = $(that).closest(".index-pro").find(".btnAddToBasket");
            var loading = $(that).closest(".load").find(".loading");
            $(cart).fadeOut("fast");
            $(loading).fadeIn("fast");

            var productID = $(that).attr("data-id");

            var params = {
                productID: productID,
                CartType: 'Stock',
                Quantity: 1
            };

            return angular
                .element(".cart-controller")
                .scope()
                .vm.InsertWithParams(params)
                .then(function () {
                    $(that).attr("disabled", false);
                    $(cart).fadeIn("fast");
                    $(loading).fadeOut("fast");
                    var success = $(that).closest(".border-urun").find(".SuccessText");
                    $(success).fadeIn("fast").delay(3000).fadeOut("fast");
                    callback(that);
                });
        }
    },
    AddDiscount: function (that, callback) {
        if (!userId) {
            window.location = "/account/loginorsignup?ReturnUrl=" + window.location.href;
            return;
        } else {
            $(that).attr("disabled", true);
            var cart = $(that).closest(".index-pro").find(".btnAddToBasket");
            var loading = $(that).closest(".load").find(".loading");
            $(cart).fadeOut("fast");
            $(loading).fadeIn("fast");

            var productID = $(that).attr("data-id");

            var params = {
                productID: productID,
                CartType: 'Discount',
                Quantity: 1
            };
            return angular
                .element(".cart-controller")
                .scope()
                .vm.InsertWithParams(params)
                .then(function () {
                    $(that).attr("disabled", false);
                    $(cart).fadeIn("fast");
                    $(loading).fadeOut("fast");
                    var success = $(that).closest(".border-urun").find(".SuccessText");
                    $(success).fadeIn("fast").delay(3000).fadeOut("fast");
                    callback(that);
                });
        }
    },
    AddCartAndGo: function (that) {
        $(that).attr("disabled", true);
        var variantValues = $.Cart.GetVariantData(that);

        var loadingCart = $(that).closest(".load").find(".loading");
        $(loadingCart).fadeIn("fast");
        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var defaultQuantity = $.Util.ToNumber($(that).attr("data-quantity"));
        var addToCartAmount = $(that)
            .parent()
            .find("[name='addToCartAmount']");
        var quantity = parseFloat($(addToCartAmount).val());
        var price = $(that).attr("data-price-with-discount");
        var params = {
            productID: productID,
            quantity: quantity || defaultQuantity
        };

        $.FacebookPixel.AddToCart(productCode, price);

        var googleProduct = {
            id: productCode,
            name: name,
            list_name: "Search Results",
            variant: variantValues,
            quantity: quantity,
            price: price
        }

        $.Analytics.Add_To_Cart(googleProduct);

        return angular
            .element(".cart-controller")
            .scope()
            .vm.InsertWithParams(params)
            .then(function () {
                $(that).attr("disabled", false);
                window.location = "/Checkout/Checkout";
            }, function (error) {
                $(that).attr("disabled", false);
                alert(error)
            });
    },
    FastBuy: function (that) {
        $(that).attr("disabled", true);
        var variantValues = $.Cart.GetVariantData(that);

        var loadingCart = $(that).closest(".load").find(".loading");
        $(loadingCart).fadeIn("fast");
        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var defaultQuantity = $.Util.ToNumber($(that).attr("data-quantity"));
        var addToCartAmount = $(that)
            .parent()
            .find("[name='addToCartAmount']");
        var quantity = parseFloat($(addToCartAmount).val());
        var price = $(that).attr("data-price-with-discount");
        var params = {
            productID: productID,
            quantity: quantity || defaultQuantity
        };

        $.FacebookPixel.AddToCart(productCode, price);

        var googleProduct = {
            id: productCode,
            name: name,
            list_name: "Search Results",
            variant: variantValues,
            quantity: quantity,
            price: price
        }

        $.Analytics.Add_To_Cart(googleProduct);

        return angular
            .element(".cart-controller")
            .scope()
            .vm.InsertWithParams(params)
            .then(function () {
                $(that).attr("disabled", false);
                window.location = "/Checkout/Checkout?fastBuy=true";
            }, function (error) {
                $(that).attr("disabled", false);
                alert(error)
            });
    },
    GetVariantData: function (that) {
        var variantValues = {};
        var variantFormData = $(that)
            .closest(".product-add-to-cart")
            .find(".variant-form .option-wrapper");

        $.each(variantFormData, function (i, item) {
            if ($(item).find("input:checked").attr("value-text")) {
                var key = $(item).find("input:checked").attr("name");
                var value = $(item).find("input:checked").attr("value-text");
                variantValues[key] = value;
            }
            $.each($(item).find("select"), function (j, subitem) {
                if ($(subitem).find("option:selected").text()) {
                    var key = $(subitem).attr("name");
                    var value = $(subitem).find("option:selected").text();
                    variantValues[key] = value;
                }
            });
            $.each($(item).find("input[type='text']"), function (j, subitem) {
                if ($(subitem).val()) {
                    var key = $(subitem).attr("name");
                    var value = $(subitem).val();
                    variantValues[key] = value;
                }
            });
        });
        return variantValues;
    },
    AddCartDetail: function (that) {

        $(that).attr("disabled", true);
        var variantValues = $.Cart.GetVariantData(that);

        var addCartType = $("#CartController").attr("add-cart-type");
        if (addCartType === "cart") {
            var loading = $(that)
                .closest(".product-add-to-cart")
                .find(".loading");
            $(loading).fadeIn("fast");
        } else if (addCartType === "popup") {
            $("#add-cart-modal .cart-modal-loading").show();
            $("#add-cart-modal .cart-modal-content").hide();
            $("#add-cart-modal").modal("show");
        } else {
            var loadingCart = $(that)
                .closest(".product-add-to-cart")
                .find(".loading");
            $(loadingCart).fadeIn("fast");
        }

        var addToCartAmount = $(that)
            .parent()
            .find("[name='addToCartAmount']");
        var quantity = parseFloat($(addToCartAmount).val());
        if (
            $(that)
            .parent()
            .find(".overage-control")
        ) {
            var overage = parseFloat(
                $(that)
                .parent()
                .find(".overage-control select")
                .val() || 0
            );
            var quantity2 = parseFloat(
                $(that)
                .parent()
                .find(".overage-control")
                .parent()
                .find("[name='addToCartAmount']")
                .val() || 1
            );
            var newQuantity = Math.ceil(quantity + (quantity * overage) / 100);
            quantity2 = newQuantity;
        }
        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var image = $(that).attr("data-img");

        var name = $(that).attr("data-name");
        var defaultQuantity = $.Util.ToNumber($(that).attr("data-quantity"));
        var price = $(that).attr("data-price-with-discount");

        $.FacebookPixel.AddToCart(productCode, price);
        var googleProduct = {
            id: productCode,
            name: name,
            brand: product.Brand,
            category: product.category,
            list_name: "Search Results",
            quantity: quantity2,
            variant: product.variant,
            price: price

        }
        $.Analytics.Add_To_Cart(googleProduct);

        var params = {
            productID: productID,
            quantity: quantity || defaultQuantity,
            variantValues: variantValues
        };

        return angular
            .element("#CartController")
            .scope()
            .vm.InsertWithParams(params)
            .then(function () {
                $(that).attr("disabled", false);
                if (addCartType === "popup") {
                    $("#add-cart-modal .cart-modal-product-image").attr("src", imageServer + "/" + image);
                    $("#add-cart-modal .cart-modal-product-name").html(name);
                    $("#add-cart-modal .cart-modal-loading").hide();
                    $("#add-cart-modal .cart-modal-content").show();
                } else if (addCartType === "cart") {
                    window.location = "/Cart/Index";
                } else {
                    var success = $(that)
                        .closest(".product-add-to-cart")
                        .find(".SuccessTextDetail");
                    var loading = $(that)
                        .closest(".product-add-to-cart")
                        .find(".loading");
                    $(loading).fadeOut("fast");
                    $(success)
                        .fadeIn("fast")
                        .delay(3000)
                        .fadeOut("fast");
                }
            }, function (error) {
                $(that).attr("disabled", false);
                if (addCartType === "popup") {
                    $("#add-cart-modal").modal("hide");
                } else if (addCartType === "cart") {} else {
                    var loading = $(that)
                        .closest(".product-add-to-cart")
                        .find(".loading");
                    $(loading).fadeOut("fast");
                }
                alert(error)
            });
    },
    AddCartAndGoDetail: function (that) {
        $(that).attr("disabled", true);
        var addCartType = $("#CartController").attr("add-cart-type");
        var loading = $(that)
            .closest(".product-add-to-cart")
            .find(".loading");
        $(loading).fadeIn("fast");

        var addToCartAmount = $(that)
            .parent()
            .find("[name='addToCartAmount']");
        var quantity = parseFloat($(addToCartAmount).val());
        if (
            $(that)
            .parent()
            .find(".overage-control")
        ) {
            var overage = parseFloat(
                $(that)
                .parent()
                .find(".overage-control select")
                .val() || 0
            );
            var quantity2 = parseFloat(
                $(that)
                .parent()
                .find(".overage-control")
                .parent()
                .find("[name='addToCartAmount']")
                .val() || 1
            );
            var newQuantity = Math.ceil(quantity + (quantity * overage) / 100);
            quantity2 = newQuantity;
        }
        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var price = $(that).attr("data-price-with-discount");
        $.FacebookPixel.AddToCart(productID, price);

        var params = {
            productID: productID,
            quantity: quantity
        };

        return angular
            .element("#CartController")
            .scope()
            .vm.InsertWithParams(params)
            .then(function () {
                $(that).attr("disabled", false);
                window.location = "/Checkout/Checkout";
            }, function (error) {
                $(that).attr("disabled", false);
                alert(error)
            });
    },
    FastBuyDetail: function (that) {
        $(that).attr("disabled", true);
        var addCartType = $("#CartController").attr("add-cart-type");
        var loading = $(that)
            .closest(".product-add-to-cart")
            .find(".loading");
        $(loading).fadeIn("fast");

        var addToCartAmount = $(that)
            .parent()
            .find("[name='addToCartAmount']");
        var quantity = parseFloat($(addToCartAmount).val());
        if (
            $(that)
                .parent()
                .find(".overage-control")
        ) {
            var overage = parseFloat(
                $(that)
                    .parent()
                    .find(".overage-control select")
                    .val() || 0
            );
            var quantity2 = parseFloat(
                $(that)
                    .parent()
                    .find(".overage-control")
                    .parent()
                    .find("[name='addToCartAmount']")
                    .val() || 1
            );
            var newQuantity = Math.ceil(quantity + (quantity * overage) / 100);
            quantity2 = newQuantity;
        }
        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var price = $(that).attr("data-price-with-discount");
        $.FacebookPixel.AddToCart(productID, price);

        var params = {
            productID: productID,
            quantity: quantity
        };

        return angular
            .element("#CartController")
            .scope()
            .vm.InsertWithParams(params)
            .then(function () {
                $(that).attr("disabled", false);
                window.location = "/Checkout/Checkout?fastBuy=true";
            }, function (error) {
                $(that).attr("disabled", false);
                alert(error)
            });
    },
    FastBuyTPDetail: function (that) {
        $(that).attr("disabled", true);
        var addCartType = $("#CartController").attr("add-cart-type");
        var loading = $(that)
            .closest(".product-add-to-cart")
            .find(".loading");
        $(loading).fadeIn("fast");

        var quantity = parseFloat($(that).attr("data-quantity"));
        if (
            $(that)
                .parent()
                .find(".overage-control")
        ) {
            var overage = parseFloat(
                $(that)
                    .parent()
                    .find(".overage-control select")
                    .val() || 0
            );
            var quantity2 = parseFloat(
                $(that)
                    .parent()
                    .find(".overage-control")
                    .parent()
                    .find("[name='addToCartAmount']")
                    .val() || 1
            );
            var newQuantity = Math.ceil(quantity + (quantity * overage) / 100);
            quantity2 = newQuantity;
        }
        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var price = $(that).attr("data-price-with-discount");
        $.FacebookPixel.AddToCart(productID, price);

        var params = {
            productID: productID,
            quantity: quantity
        };

        return angular
            .element("#CartController")
            .scope()
            .vm.InsertWithParams(params)
            .then(function () {
                $(that).attr("disabled", false);
                window.location = "/Checkout/Checkout?fastBuy=true";
            }, function (error) {
                $(that).attr("disabled", false);
                alert(error)
            });
    },
    IsInCart: function (params) {
        return angular
            .element(".cart-controller")
            .scope()
            .vm.IsInCart(params)
            .then(function (data) {
                return data;
            });
    },
    RemoveCartProduct: function (that, cartType, callback) {
        var cartProductId = $(that).attr("data-cart-product-id");
        var params = {
            Id: cartProductId
        };
        return angular
            .element(".cart-controller")
            .scope()
            .vm.Delete(params, cartType)
            .then(function (data) {
                callback(that);
                return data;
            });
    }
};

$.Product = {
    Search: function (that) {
        var noKeys = "";
        var noKeyIndex = noKeys.indexOf(that.which);
        if (noKeyIndex < 0) {
            $("#SearchResult").html("");
            var charVal = encodeURIComponent($(that).val());
            var charCulture = encodeURIComponent($(that).attr("Culture"));
            var charLength = charVal.length;
            if (charLength > 1) {
                $("#SearchResult").show();
                $("#SearchResult").html('<span class="loading" style="padding:70px 140px;">Ürünler filtreleniyor...</span>');
                clearTimeout(window.getSearchTimer);
                window.getSearchTimer = setTimeout("$.Product.SearchItems('" + charVal + "','" + charCulture + "')", 500);
            } else {
                $("#SearchResult").hide();
            }
        }
    },
    SearchItems: function (charVal, charCulture) {
        $.ajax({
            url: (charCulture ? "/" + charCulture : "") + "/General/Search",
            type: "GET",
            cache: false,
            data: {
                search: charVal
            },
            success: function (data) {
                $("#SearchResult").html(data);
            }
        });
    },
    Sort: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = that.split("_")[0];
        var SortType = that.split("_")[1];
        var PageIndex = $.Url.QueryString("PageIndex", url);
        var Brand = $.Url.QueryString("Brand", url);
        var Tags = $.Url.QueryString("Tags", url);
        var Collection = $.Url.QueryString("Collection", url);
        var Options = $.Url.AllQueryString().filter(function (item) {
            return item.Id.includes("opt.");
        });
        var optList = "";
        if (Options.length > 0) {
            $.each(Options, function (index, item) {
                optList += item.Id + "=" + item.value + "&";
            });
        }
        var MinPrice = $.Url.QueryString("MinPrice", url);
        var MaxPrice = $.Url.QueryString("MaxPrice", url);
        window.location =
            baseurl +
            "?" +
            (MinPrice ? "MinPrice=" + MinPrice + "&" : "") +
            (MaxPrice ? "MaxPrice=" + MaxPrice + "&" : "") +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Brand ? "Brand=" + Brand + "&" : "") +
            (Tags ? "Tags=" + Tags + "&" : "") +
            (Collection ? "Collection=" + Collection + "&" : "") +
            (Options.length > 0 ? optList + "&" : "");
    },
    ChangeSize: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var PageIndex = $.Url.QueryString("PageIndex", url);
        var PageSize = that;
        var Brand = $.Url.QueryString("Brand", url);
        var Tags = $.Url.QueryString("Tags", url);
        var Collection = $.Url.QueryString("Collection", url);
        var Options = $.Url.AllQueryString().filter(function (item) {
            return item.Id.includes("opt.");
        });
        var optList = "";
        if (Options.length > 0) {
            $.each(Options, function (index, item) {
                optList += item.Id + "=" + item.value + "&";
            });
        }
        var MinPrice = $.Url.QueryString("MinPrice", url);
        var MaxPrice = $.Url.QueryString("MaxPrice", url);
        window.location =
            baseurl +
            "?" +
            (MinPrice ? "MinPrice=" + MinPrice + "&" : "") +
            (MaxPrice ? "MaxPrice=" + MaxPrice + "&" : "") +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Brand ? "Brand=" + Brand + "&" : "") +
            (Tags ? "Tags=" + Tags + "&" : "") +
            (Collection ? "Collection=" + Collection + "&" : "") +
            (Options.length > 0 ? optList + "&" : "") +
            (PageSize ? "PageSize=" + PageSize + "&" : "");
    },
    FilterByPrice: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var PageIndex = $.Url.QueryString("PageIndex", url);
        var Brand = $.Url.QueryString("Brand", url);
        var Tags = $.Url.QueryString("Tags", url);
        var Collection = $.Url.QueryString("Collection", url);
        var Options = $.Url.AllQueryString().filter(function (item) {
            return item.Id.includes("opt.");
        });
        var optList = "";
        if (Options.length > 0) {
            $.each(Options, function (index, item) {
                optList += item.Id + "=" + item.value + "&";
            });
        }
        var MinPrice = that[0];
        var MaxPrice = that[1];
        window.location =
            baseurl +
            "?" +
            (MinPrice ? "MinPrice=" + MinPrice + "&" : "") +
            (MaxPrice ? "MaxPrice=" + MaxPrice + "&" : "") +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Brand ? "Brand=" + Brand + "&" : "") +
            (Tags ? "Tags=" + Tags + "&" : "") +
            (Collection ? "Collection=" + Collection + "&" : "") +
            (Options.length > 0 ? optList + "&" : "");
    },
    FilterByBrand: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var MinPrice = $.Url.QueryString("MinPrice", url);
        var MaxPrice = $.Url.QueryString("MaxPrice", url);
        var QueryBrand = $.Url.QueryString("Brand", url);
        var Tags = $.Url.QueryString("Tags", url);
        var Collection = $.Url.QueryString("Collection", url);
        var Options = $.Url.AllQueryString().filter(function (item) {
            return item.Id.includes("opt.");
        });
        var optList = "";
        if (Options.length > 0) {
            $.each(Options, function (index, item) {
                optList += item.Id + "=" + item.value + "&";
            });
        }
        var Brand = "";
        if (QueryBrand) {
            if (QueryBrand.includes($(that).val())) {
                Brand = QueryBrand.replace("," + $(that).val(), "")
                    .replace($(that).val() + ",", "")
                    .replace($(that).val(), "");
            } else {
                Brand = (QueryBrand ? QueryBrand + "," : "") + $(that).val();
            }
        } else {
            Brand = $(that).val();
        }
        window.location =
            baseurl +
            "?" +
            (MinPrice ? "MinPrice=" + MinPrice + "&" : "") +
            (MaxPrice ? "MaxPrice=" + MaxPrice + "&" : "") +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Brand ? "Brand=" + Brand + "&" : "") +
            (Tags ? "Tags=" + Tags + "&" : "") +
            (Collection ? "Collection=" + Collection + "&" : "") +
            (Options.length > 0 ? optList + "&" : "");
    },
    FilterByTag: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var MinPrice = $.Url.QueryString("MinPrice", url);
        var MaxPrice = $.Url.QueryString("MaxPrice", url);
        var Brand = $.Url.QueryString("Brand", url);
        var QueryTags = $.Url.QueryString("Tags", url);
        var Collection = $.Url.QueryString("Collection", url);
        var Options = $.Url.AllQueryString().filter(function (item) {
            return item.Id.includes("opt.");
        });
        var optList = "";
        if (Options.length > 0) {
            $.each(Options, function (index, item) {
                optList += item.Id + "=" + item.value + "&";
            });
        }
        var Tags = "";
        if (QueryTags) {
            if (QueryTags.includes($(that).val())) {
                Tags = QueryTags.replace("," + $(that).val(), "")
                    .replace($(that).val() + ",", "")
                    .replace($(that).val(), "");
            } else {
                Tags = (QueryTags ? QueryTags + "," : "") + $(that).val();
            }
        } else {
            Tags = $(that).val();
        }
        window.location =
            baseurl +
            "?" +
            (MinPrice ? "MinPrice=" + MinPrice + "&" : "") +
            (MaxPrice ? "MaxPrice=" + MaxPrice + "&" : "") +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Brand ? "Brand=" + Brand + "&" : "") +
            (Tags ? "Tags=" + Tags + "&" : "") +
            (Collection ? "Collection=" + Collection + "&" : "") +
            (Options.length > 0 ? optList + "&" : "");
    },
    FilterAll: function (formName) {
        if (!formName) {
            formName = "filter-desktop-form";
        }
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var serializedInputList = {};
        $.each($('[name="' + formName + '"]').serializeArray(), function () {
            serializedInputList[this.name] = (serializedInputList[this.name] || '') + this.value + ',';
        });
        var serializedInputString = '';
        $.each(serializedInputList, function (i, item) {
            serializedInputString += (i + '=' + item.slice(0, -1) + '&');
        });
        var url = baseurl +
            "?" +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            serializedInputString.slice(0, -1);
        window.location = url;
    },
    FilterByCollection: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var MinPrice = $.Url.QueryString("MinPrice", url);
        var MaxPrice = $.Url.QueryString("MaxPrice", url);
        var Brand = $.Url.QueryString("Brand", url);
        var Tags = $.Url.QueryString("Tags", url);
        var QueryCollection = $.Url.QueryString("Collection", url);
        var Options = $.Url.AllQueryString().filter(function (item) {
            return item.Id.includes("opt.");
        });
        var optList = "";
        if (Options.length > 0) {
            $.each(Options, function (index, item) {
                optList += item.Id + "=" + item.value + "&";
            });
        }
        var Collection = (QueryCollection ? QueryCollection + "," : "") + $(that).val();
        window.location =
            baseurl +
            "?" +
            (MinPrice ? "MinPrice=" + MinPrice + "&" : "") +
            (MaxPrice ? "MaxPrice=" + MaxPrice + "&" : "") +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Brand ? "Brand=" + Brand + "&" : "") +
            (Tags ? "Tags=" + Tags + "&" : "") +
            (Collection ? "Collection=" + Collection + "&" : "") +
            (Options.length > 0 ? optList + "&" : "");
    },
    ClearAllFilter: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        window.location =
            baseurl +
            "?" +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "");
    },
    ClearFilter: function (name, value) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var serializedInputList = {};
        $.each($('[name="filter-desktop-form"]').serializeArray(), function () {
            if (this.name == name && this.value == value)
                return;
            serializedInputList[this.name] = (serializedInputList[this.name] || '') + this.value + ',';
        });
        var serializedInputString = '';
        $.each(serializedInputList, function (i, item) {
            serializedInputString += (i + '=' + item.slice(0, -1) + '&');
        });
        var url = baseurl +
            "?" +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            serializedInputString.slice(0, -1);
        window.location = url;
    },
    FilterByProductOption: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var MinPrice = $.Url.QueryString("MinPrice", url);
        var MaxPrice = $.Url.QueryString("MaxPrice", url);
        var Brand = $.Url.QueryString("Brand", url);
        var Tags = $.Url.QueryString("Tags", url);
        var Collection = $.Url.QueryString("Collection", url);
        var Option = $(that).val();
        var OptionId = $(that).attr("data-id");
        var temp = $.Url.AllQueryString();
        var Options = $.Url.AllQueryString().filter(function (item) {
            return item.Id.includes("opt.");
        });
        var optList = "";
        if (Options.length > 0) {
            $.each(Options, function (index, item) {
                var optionEncoded = encodeURI(Option);
                if (item.Id == "opt." + OptionId && !item.value.includes(optionEncoded)) {
                    optList += item.Id + "=" + item.value + "," + optionEncoded + "&";
                } else if (item.Id == "opt." + OptionId && item.value.includes(optionEncoded)) {
                    var result = item.value
                        .replace("," + optionEncoded, "")
                        .replace(optionEncoded + ",", "")
                        .replace(optionEncoded, "");

                    if (!result) {
                        return true;
                    }
                    optList += item.Id + "=" + result + "&";
                } else {
                    optList += item.Id + "=" + item.value + "&";
                    if (index === Options.length - 1) {
                        optList += "opt." + OptionId + "=" + optionEncoded + "&";
                    }
                }
            });
        } else {
            optList = "opt." + OptionId + "=" + Option + "&";
        }
        window.location =
            baseurl +
            "?" +
            (MinPrice ? "MinPrice=" + MinPrice + "&" : "") +
            (MaxPrice ? "MaxPrice=" + MaxPrice + "&" : "") +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Brand ? "Brand=" + Brand + "&" : "") +
            (Tags ? "Tags=" + Tags + "&" : "") +
            (Collection ? "Collection=" + Collection + "&" : "") +
            (Option ? optList : "");
    },
    FilterByWizard: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var MinPrice = $.Url.QueryString("MinPrice", url);
        var MaxPrice = $.Url.QueryString("MaxPrice", url);
        var Brand = $.Url.QueryString("Brand", url);
        var Tags = $.Url.QueryString("Tags", url);
        var Collection = $.Url.QueryString("Collection", url);
        var Option = $(that).val();
        var OptionId = $(that).attr("data-id");
        var temp = $.Url.AllQueryString();
        var Options = $.Url.AllQueryString().filter(function (item) {
            return item.Id.includes("opt.");
        });
        var optList = "";
        if (Options.length > 0) {
            $.each(Options, function (index, item) {
                var optionEncoded = encodeURI(Option);
                if (item.Id == "opt." + OptionId && !item.value.includes(optionEncoded)) {
                    optList += item.Id + "=" + item.value + "," + optionEncoded + "&";
                } else if (item.Id == "opt." + OptionId && item.value.includes(optionEncoded)) {
                    var result = item.value
                        .replace("," + optionEncoded, "")
                        .replace(optionEncoded + ",", "")
                        .replace(optionEncoded, "");

                    if (!result) {
                        return true;
                    }
                    optList += item.Id + "=" + result + "&";
                } else {
                    optList += item.Id + "=" + item.value + "&";
                    if (index === Options.length - 1) {
                        optList += "opt." + OptionId + "=" + optionEncoded + "&";
                    }
                }
            });
        } else {
            optList = "opt." + OptionId + "=" + Option + "&";
        }
        var url = baseurl +
            "?" +
            (MinPrice ? "MinPrice=" + MinPrice + "&" : "") +
            (MaxPrice ? "MaxPrice=" + MaxPrice + "&" : "") +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Brand ? "Brand=" + Brand + "&" : "") +
            (Tags ? "Tags=" + Tags + "&" : "") +
            (Collection ? "Collection=" + Collection + "&" : "") +
            (Option ? optList : "");
    },
    CreateFilterByWizard: function (that) {
        $(that).nextAll().remove();

        var optionId = $(that)
            .attr("option-id");
        var value = $(that)
            .find("option:selected")
            .val();

        if (!value || value == "...") {
            var url = window.location.href;
            var optionValue = $.Url.QueryString("opt." + optionId, url);
            if (optionValue) {
                $(that).find('[value="' + optionValue + '"]').attr('selected', 'selected');
            }
        }

        var text = $(that)
            .find("option:selected")
            .text();
        var optionValueId = $(that)
            .find("option:selected")
            .attr("option-value-id");


        if (value) {
            $(that).attr("name", "opt." + optionId);
        }
        var subOptionList = $('[top-option-value-id="' + optionValueId + '"]');
        $(that)
            .closest(".filter-wizard")
            .find(".btn-wizard")
            .val(text)
            .attr("data-id", optionId);

        if (subOptionList.length) {
            var select = '<select class="form-control" option-id="' + $(subOptionList[0]).attr("option-id") + '" onchange="$.Product.CreateFilterByWizard(this)"><option value="">...</option>';
            for (var i = 0; i < subOptionList.length; i++) {
                var opt = subOptionList[i];
                select += opt.outerHTML;
            }
            select += "</select>";
            $(that)
                .closest(".wizard-select-wrapper")
                .append(select);

            $('[option-id="' + $(subOptionList[0]).attr("option-id") + '"]').change();

        }
    },
    Review: function (that) {
        var form = $(that)
            .closest("form")
            .get(0);
        $.ajax({
            url: "/General/Review",
            data: $(form).serialize(),
            type: "POST",
            success: function (result) {
                console.log("form",form);
                //$(".btn-do-review").click();
                $("#reviewRate").rateYo("rating", 0);
                $(that)
                    .closest("form")
                    .find("input[name='Title']")
                    .val("");
                $(that)
                    .closest("form")
                    .find("textarea[name='Text']")
                    .val("");
                var review = $(that)
                    .closest("form")
                    .find(".ReviewSuccessText");
                $(review)
                    .fadeIn("slow")
                    .delay(3000)
                    .fadeOut("fast");
                console.log("review",review);
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                var review = $(that)
                    .closest("form")
                    .find(".ReviewFailure");
                $(review)
                    .fadeIn("slow")
                    .delay(3000)
                    .fadeOut("fast");
            }
        });
    }
};

$.Url = {
    QueryString: function (name, url) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    AllQueryString: function () {
        var vars = [],
            hash;
        var q = document.URL.split("?")[1];
        if (q != undefined) {
            q = q.split("&");
            for (var i = 0; i < q.length; i++) {
                hash = q[i].split("=");
                //vars.push(hash[1]);
                //vars[hash[0]] = hash[1];
                vars.push({
                    Id: hash[0],
                    value: hash[1]
                });
            }
        }
        return vars;
    }
};

$.Review = {
    LoadMore: function (that, callback) {
        var Date = $(that).attr("data-date");
        var PId = $(that).attr("data-product");
        var LMore = $(that);
        LMore.before('<img src="/images/loader.gif" class="yukleniyor" />');
        LMore.hide();
        $.ajax({
            type: "POST",
            url: "/General/LoadMore",
            data: {
                LastDate: Date,
                ProductId: PId
            },
            cache: false,
            success: function (data) {
                if (data.LastDate === -1) {
                    LMore.before("<span>Başka Kayıt Bulunamadı</span>");
                    $(".yukleniyor").remove();
                    LMore.remove();
                    return;
                }
                $.each(data.m, function (i, item) {
                    var UserDate = moment(item.InsertDate).format("DD.MM.YYYY");
                    $(".reviewGen").append(
                        '<div class="reviewList" data-date="' +
                        item.InsertDate +
                        '" data-product="' +
                        item.ProductId +
                        '">' +
                        '<div class="reviewL">' +
                        '<div class="reviewInfo">' +
                        '<div class="reviewHead">' +
                        "<span>" +
                        item.ReviewTitle +
                        "</span>" +
                        '<span class="reviewHead-user">' +
                        item.User.Name +
                        " " +
                        item.User.Surname +
                        " - " +
                        UserDate +
                        "</span>" +
                        "</div>" +
                        '<div class="listRate" data-value=' +
                        item.Rating +
                        '></div><div class="reviewMessage">' +
                        item.ReviewText +
                        "</div>" +
                        "</div>" +
                        "</div>" +
                        "</div>"
                    );
                    $(".reviewGen .reviewList:last").fadeIn("slow");

                    $(".listRate").each(function (i, obj) {
                        ratingValue = obj.attributes["data-value"].value;
                        if (ratingValue !== null) {
                            $(obj).rateYo({
                                starWidth: "20px",
                                rating: ratingValue,
                                readOnly: true
                            });
                        }
                    });
                });
                LastDate(data.LastDate);

                function LastDate(load) {
                    var date;
                    if (load === null) {
                        date = $(".reviewGen .reviewList:last").attr("data-date");
                    } else {
                        date = load;
                    }
                    $(".load").attr({
                        "data-date": date,
                        "data-product": data.ProductId
                    });
                }
                $(".yukleniyor").remove();
                LMore.show();
            }
        });
        return false;
    },
    Sort: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = that.split("_")[0];
        var SortType = that.split("_")[1];
        var PageIndex = $.Url.QueryString("PageIndex", url);
        var Rates = $.Url.QueryString("Rates", url);

        window.location =
            baseurl +
            "?" +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Rates ? "Rates=" + Rates + "&" : "");
    },
    FilterByRate: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var QueryRates = $.Url.QueryString("Rates", url);
        var Rates = "";
        if (QueryRates) {
            if (QueryRates.includes($(that).val())) {
                Rates = QueryRates.replace("," + $(that).val(), "")
                    .replace($(that).val() + ",", "")
                    .replace($(that).val(), "");
            } else {
                Rates = (QueryRates ? QueryRates + "," : "") + $(that).val();
            }
        } else {
            Rates = $(that).val();
        }
        window.location =
            baseurl +
            "?" +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Rates ? "Rates=" + Rates + "&" : "");
    }
};

$.Favorite = {
    Like: function (that) {
        $.ajax({
            type: "POST",
            url: "/General/Favorite/Like",
            data: {
                Id: $(that).attr("data-fav")
            },
            cache: false,
            success: function (data) {
                $(that)
                    .closest(".comment-like-dislike")
                    .append("<span>Teşekkür Ederiz</span>");
                $(that)
                    .closest(".btn-group")
                    .remove();
            }
        });
    },
    Dislike: function (that) {
        $.ajax({
            type: "POST",
            url: "/General/Favorite/Dislike",
            data: {
                Id: $(that).attr("data-fav")
            },
            cache: false,
            success: function (data) {
                $(that)
                    .closest(".comment-like-dislike")
                    .append("<span> Teşekkür Ederiz</span>");
                $(that)
                    .closest(".btn-group")
                    .remove();
            }
        });
    }
};

$.Blog = {
    Search: function (that) {
        var noKeys = "";
        var noKeyIndex = noKeys.indexOf(that.which);
        if (noKeyIndex < 0) {
            $("#SearchResult").html("");
            var charVal = encodeURIComponent($(that).val());
            var charLength = charVal.length;

            if (charLength > 1) {
                $("#SearchResult").show();
                $("#SearchResult").html(
                    '<span class="loading" style="padding:70px 140px;">Blog Postları filtreleniyor...</span>'
                );

                clearTimeout(getSearchTimer);

                var getSearchTimer = setTimeout("$.Blog.SearchItems('" + charVal + "')", 1500);
            } else {
                $("#SearchResult").hide();
            }
        }
    },
    SearchItems: function (charVal) {
        $.ajax({
            url: "/General/BlogPostSearch",
            type: "GET",
            cache: false,
            data: {
                search: charVal
            },
            success: function (data) {
                $("#SearchResult").html(data);
            }
        });
    }
};

$.Util = {
    ToNumber: function (item) {
        if (item) {
            var val = item.toString().replace(",", ".");
            return Number(val);
        } else {
            return Number("0");
        }
    },

    ToString: function (item) {
        var val = item.toString().replace(".", ",");
        return val;
    },

    ToFloat: function (item) {
        if (item) {
            return parseFloat(item.toString().replace(",", "."));
        } else {
            return parseFloat("0");
        }
    },

    ToPrecision: function (item) {
        return parseFloat(item.toFixed(2).split(".")[1]);
    },

    ToFloor: function (item) {
        return parseFloat((item + "").split(".")[0]);
    },

    ToFillZero: function (item, width) {
        return item.length >= width ? item : (new Array(width).join("0") + item).slice(-width);
    },

    ByString: function (o, s) {
        s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
        s = s.replace(/^\./, ""); // strip a leading dot
        var a = s.split(".");
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return;
            }
        }
        return o;
    },

    GroupBy: function (xs, key) {
        return xs.reduce(function (rv, x) {}, {});
    }
};

$.Cookie = {
    setCookie: function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + (cvalue || "") + ";" + expires + ";path=/";
    },

    getCookie: function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    deleteCookie: function (name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
};

$.Analytics = {
    View_Item_List: function (product) {
        if (gtag) {

            gtag("event", "view_item_list", {
                items: [{
                    id: product.Id,
                    name: product.Name,
                    list_name: "List",
                    brand: product.Brand,
                    category: product.category,
                    variant: "",
                    list_position: product.DisplayOrder,
                    quantity: product.Quantity,
                    price: product.Price
                }]
            });
        } else {
            // console.log("gtag not found");
        }
    },
    Select_Content: function (product) {
        if (gtag) {
            gtag("event", "view_item", {
                items: [{
                    id: product.Id,
                    name: product.Name,
                    list_name: "List",
                    category: product.category,
                    variant: "",
                    brand: product.Brand,
                    quantity: product.Quantity,
                    price: product.Price
                }]
            });
        } else {
            //  console.log("gtag not found");
        }
    },
    View_Item: function (product) {

        if (gtag) {
            var productsData = [];
            for (var i = 0; i < product.length; i++) {
                productsData[i] = {
                    id: product[i].id,
                    name: product[i].Name,
                    brand: product[i].Brand,
                    category: product[i].Category,
                    variant: product[i].Name,
                    list_position: product[i].DisplayOrder,
                    quantity: product[i].DefaultQuantity,
                    price: product[i].Price,
                    aggregateRating: product[i].Price,
                    priceValidUntil: "",
                    url: window.location.href,
                    sku: product[i].Id,
                    rewiev: product[i].rewiev
                };

            }

            gtag("event", "view_item", {
                items: productsData
            });
        } else {
            //   console.log("gtag not found");
        }
    },
    Add_To_Cart: function (product) {
        if (gtag) {
            gtag("event", "add_to_cart", {
                items: [{
                    id: product.Id,
                    name: product.name,
                    list_name: "Search Results",
                    brand: product.Brand,
                    category: product.category,
                    variant: product.variant,
                    quantity: product.quantity,
                    price: product.price
                }]
            });
        } else {
            // console.log("gtag not found");
        }
    },
    Removo_From_Cart: function (product) {
        if (gtag) {
            gtag("event", "remove_from_cart", {
                items: [{
                    id: product.Id,
                    name: product.name,
                    list_name: "Search Results",
                    brand: product.Brand,
                    category: product.category,
                    variant: "",
                    quantity: product.DefaultQuantity,
                    price: product.Price
                }]
            });
        } else {
            //  console.log("gtag not found");
        }
    },
    //View_Promotion: function (that) {
    //	if (GoogleAnalyticsCode) {
    //		gtag('event', 'view_promotion', {
    //			"promotions": [
    //				{
    //					"id": "abc123",
    //					"name": "summer_promo"
    //				},
    //				{
    //					"id": "xyz987",
    //					"name": "spring savings"
    //				}
    //			]
    //		});
    //	}
    //},
    //Promotion_Select_Content: function (that) {
    //	if (GoogleAnalyticsCode) {
    //		gtag('event', 'select_content', {
    //			"promotions": [
    //				{
    //					"id": "abc123",
    //					"name": "summer_promo"
    //				}
    //			]
    //		});
    //	}
    //},
    Begin_Checkout: function (product) {
        if (gtag) {
            gtag("event", "begin_checkout", {
                items: [{
                    id: product.Id,
                    name: product.name,
                    list_name: "Search Results",
                    brand: product.Brand,
                    category: product.category,
                    variant: "",
                    list_position: product.DisplayOrder,
                    quantity: product.DefaultQuantity,
                    price: product.Price
                }],
                coupon: ""
            });
        } else {
            // console.log("gtag not found");
        }
    },
    Checkout_Progress: function (product) {
        if (gtag) {
            gtag("event", "begin_checkout", {
                items: [{
                    id: product.Id,
                    name: product.name,
                    list_name: "Search Results",
                    brand: product.Brand,
                    category: product.category,
                    variant: "",
                    list_position: product.DisplayOrder,
                    quantity: product.DefaultQuantity,
                    price: product.Price
                }],
                coupon: ""
            });
        } else {
            // console.log("gtag not found");
        }
    },
    //Set_Checkout_Option: function (that) {
    //	if (GoogleAnalyticsCode) {
    //		gtag('event', 'set_checkout_option', {
    //			"checkout_step": 1,
    //			"checkout_option": "shipping method",
    //			"value": "USPS"
    //		});
    //	}
    //},
    Purchase: function (product) {
        if (gtag) {
            var productsData = [];
            for (var i = 0; i < product.products.length; i++) {
                productsData[i] = {
                    id: product.products[i].Code,
                    name: product.products[i].Name,
                    brand: product.products[i].Brand,
                    category: product.products[i].Category,
                    variant: product.products[i].Name,
                    list_position: product.products[i].DisplayOrder,
                    quantity: product.products[i].DefaultQuantity,
                    price: product.products[i].Price,
                    list_name: "Search Results"
                };
            }
            gtag("event", "purchase", {
                transaction_id: product.transaction_id,
                affiliation: product.affiliation,
                value: product.price, //toplam sepet miktarı
                currency: "TRY",
                tax: 0, //vergi
                shipping: 0, //kargo ücreti
                items: productsData
            });
        } else {
            //   console.log("gtag not found");
        }
    }
    //Refund: function () {
    //	if (GoogleAnalyticsCode) {
    //		gtag('event', 'refund', {
    //			"transaction_id": "79.18502354114992",
    //			"affiliation": "Google online store",
    //			"value": 23.07,
    //			"currency": "USD",
    //			"tax": 1.24,
    //			"shipping": 0,
    //			"items": [
    //				{
    //					"id": "P12345",
    //					"name": "Android Warhol T-Shirt",
    //					"list_name": "Search Results",
    //					"brand": "Google",
    //					"category": "Apparel/T-Shirts",
    //					"variant": "Black",
    //					"list_position": 1,
    //					"quantity": 2,
    //					"price": '2.0'
    //				},
    //				{
    //					"id": "P67890",
    //					"name": "Flame challenge TShirt",
    //					"list_name": "Search Results",
    //					"brand": "MyBrand",
    //					"category": "Apparel/T-Shirts",
    //					"variant": "Red",
    //					"list_position": 2,
    //					"quantity": 1,
    //					"price": '3.0'
    //				}
    //			]
    //		});
    //	}
    //}
};

$.FacebookPixel = {
    PageView: function () {
        if (fbq) {
            fbq("track", "PageView");
        }
    },
    ViewContent: function (product) {
        if (fbq) {
            if (product.length > 1) {
                var prc = product[0].PriceWithDiscount;
                fbq("track", "ViewContent", {
                    content_type: "product_group",
                    content_ids: [product[0].Code],
                    content_name: product[0].Name,
                    content_category: product[0].category,
                    currency: "TRY",
                    url: product.url,
                    value: prc
                });

            } else {
                var prc = product[0].PriceWithDiscount;
                fbq("track", "ViewContent", {
                    content_type: "product",
                    content_ids: [product[0].Code],
                    content_name: product[0].Name,
                    content_category: product[0].category,
                    currency: "TRY",
                    url: product.url,
                    value: prc
                });
            }

        }
    },
    AddToCart: function (productID, price) {

        if (fbq) {
            fbq("track", "PageView");
            var prc = parseFloat(price.replace(",", "."));
            fbq("track", "AddToCart", {
                content_ids: [productID],
                content_type: "product",
                value: prc.toFixed(2),
                currency: "TRY"
            });
        }
    },
    Purchase: function (product) {
        if (fbq) {
            for (var i = 0; i < product.length; i++) {
                fbq("track", "PageView");
                var prc = product[i].PriceWithDiscount;
                fbq("track", "Purchase", {
                    content_ids: [product[i].Code],
                    content_type: "product",
                    content_name: product[i].Name,
                    value: prc,
                    currency: "TRY",
                    num_items: i
                });
            }

        }
    }
};


$.Integration = {
    Purchase: function (result) {

        var resultData = JSON.parse(result);
        $.FacebookPixel.Purchase(resultData.products);
        $.Analytics.Purchase(resultData);
    }
};

$.Cargo = {
    CargoStatu: function CargoStatu(datas) {

        $.ajax({
                method: "POST",
                url: "/Account/cargostatus",
                cache: false,
                data: {
                    orderId: JSON.stringify(datas)
                }
            })
            .done(function (result) {
                $("#MyPopup").modal("show");


                if (result.length == 0) {

                    document.getElementById("CargoNorWorking").style.display = "block";
                    document.getElementById("statusTable").style.display = "none";
                } else {

                    document.getElementById("CargoNorWorking").style.display = "none";
                    document.getElementById("statusTable").style.display = "block";
                    $.each(result, function (index, data) {
                        var tbody = $("#statusTable > tbody");
                        var tr = $("<tr>");
                        tr.append($("<td>", {
                            'text': data.CargoStatusDate
                        }));
                        tr.append($("<td>", {
                            'text': data.CargoLocation
                        }));
                        tr.append($("<td>", {
                            'text': data.CargoStatusName
                        }));
                        tbody.append(tr);
                    });

                }


            });
    }
}